<template>
  <div>
    <base-title
      :title="StringLanguage.workingTime"
      :subtitle="
        onBoardDone ? StringLanguage.configurations : StringLanguage.back
      "
      :link="onBoardDone ? 'configuracoes' : 'onboard'"
    />

    <div
      v-for="(period, periodIndex) in horaries"
      :key="periodIndex"
      :id="`period-${periodIndex}`"
    >
      <div
        v-if="period.days.length > 0"
        class="period-box"
        :class="{ removing: period.remove }"
      >
        <div v-if="isMobile" class="period-week mobile">
          <Splide :options="options">
            <template v-slot:controls>
              <div class="splide__arrows">
                <button class="splide__arrow splide__arrow--prev arrow-prev">
                  <i class="fal fa-chevron-left" />
                </button>
                <button class="splide__arrow splide__arrow--next arrow-next">
                  <i class="fal fa-chevron-right" />
                </button>
              </div>
            </template>

            <SplideSlide
              v-for="day in period.days"
              :key="day.weeknum"
              :class="`period-day ${day.active ? 'active' : 'inactive'}`"
            >
              <div class="day-box">
                <base-checkbox
                  @click="activeDay(period.period, day)"
                  v-model="day.active"
                  :checked="day.active"
                  center
                >
                  <p class="day">{{ dayNames[day.weeknum % 7] }}</p>
                </base-checkbox>
              </div>

              <div class="day-periods">
                <div class="horaries">
                  <div class="day-horaries">
                    <div class="period-title">
                      <base-label class="mb_0">
                        {{ StringLanguage.period }}
                        {{ period + 1 }}</base-label
                      >
                      <base-button
                        v-if="horaries.length > 1"
                        design="four-mini"
                        @click="remove(periodIndex)"
                        ><i class="fal fa-trash-alt" />
                      </base-button>
                    </div>

                    <p class="start-end">Início</p>
                    <Multiselect
                      v-model="valueFirstPeriod"
                      :options="optionsFirstPeriod"
                      :showLabels="false"
                      :showPointer="false"
                      :searchable="false"
                      :hideSelected="true"
                      :showNoResults="false"
                      placeholder="-- : --"
                    >
                      <template slot="caret">
                        <div class="chevron">
                          <i class="far fa-chevron-down"></i>
                        </div>
                      </template>
                    </Multiselect>

                    <div class="hairline" />

                    <p class="start-end">
                      Fim&nbsp;
                      <span class="next-day">({{ 'Terça-feira' }})</span>
                    </p>
                    <Multiselect
                      v-model="valueSecondPeriod"
                      :options="optionsSecondPeriod"
                      :showLabels="false"
                      :showPointer="false"
                      :searchable="false"
                      :hideSelected="true"
                      :showNoResults="false"
                      placeholder="-- : --"
                    >
                      <template slot="caret">
                        <div class="chevron">
                          <i class="far fa-chevron-down"></i>
                        </div>
                      </template>
                    </Multiselect>
                  </div>
                </div>
                <base-add
                  v-if="horaries.length === 1"
                  @click.native="add()"
                  text="Adicionar período"
                  height="260px"
                  class="mt_10"
                />
              </div>
            </SplideSlide>
          </Splide>
        </div>

        <div v-if="!isMobile" class="period-week desktop">
          <div
            v-for="day in period.days"
            :key="day.weeknum"
            :class="`period-day ${day.active ? 'active' : 'inactive'}`"
          >
            <div class="day-box">
              <base-checkbox
                @click="activeDay(period.period, day)"
                v-model="day.active"
                :checked="day.active"
                center
              >
                <p class="day">{{ dayNames[day.weeknum % 7] }}</p>
              </base-checkbox>
            </div>

            <div class="day-periods">
              <div class="horaries">
                <div class="day-horaries">
                  <div class="period-title">
                    <base-label class="mb_0">
                      {{ StringLanguage.period }}
                      {{ periodIndex + 1 }}</base-label
                    >
                    <base-button
                      v-if="horaries.length > 1"
                      design="four-mini"
                      @click="remove(periodIndex)"
                      ><i class="fal fa-trash-alt" />
                    </base-button>
                  </div>

                  <p class="start-end">Início</p>
                  <Multiselect
                    v-model="valueFirstPeriod"
                    :options="optionsFirstPeriod"
                    :showLabels="false"
                    :showPointer="false"
                    :searchable="false"
                    :hideSelected="true"
                    :showNoResults="false"
                    placeholder="-- : --"
                  >
                    <template slot="caret">
                      <div class="chevron">
                        <i class="far fa-chevron-down"></i>
                      </div>
                    </template>
                  </Multiselect>

                  <div class="hairline" />

                  <p class="start-end">
                    Fim&nbsp;
                    <span class="next-day">({{ 'Terça-feira' }})</span>
                  </p>

                  <Multiselect
                    v-model="valueSecondPeriod"
                    :options="optionsSecondPeriod"
                    :showLabels="false"
                    :showPointer="false"
                    :searchable="false"
                    :hideSelected="true"
                    :showNoResults="false"
                    placeholder="-- : --"
                  >
                    <template slot="caret">
                      <div class="chevron">
                        <i class="far fa-chevron-down"></i>
                      </div>
                    </template>
                  </Multiselect>
                </div>
              </div>
              <base-add
                v-if="horaries.length === 1"
                @click.native="add()"
                text="Adicionar período"
                height="235px"
                class="mt_10"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer Fuso -->
    <!-- <base-drawer title="Fuso horário" :open="tzDrawer">
        <base-card>
            <base-label text="Selecione um fuso horário" class="mb_25"/>
            <base-select title="Fuso horário" class="mb_5">
                <option value="">Fusos</option>
            </base-select>

            <p class="tz-value">Horário atual: <span>14:00</span></p>
        </base-card>
    </base-drawer> -->
    <div class="d-flex justify-end w-100" v-if="hasChanges()">
      <base-button design="save" @click="onSave" />
    </div>
  </div>
</template>
<script>
import WorkingTime from '@/plugins/core/schema/configurations/WorkingTime/WorkingTime';
import StoreAPI from '@/api/store';
import Vue from 'vue';

import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import Multiselect from 'vue-multiselect';
import '@/assets/css/veasy/select.css';

import { mapState } from 'vuex';
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseCheckbox from '@/components/Checkbox';
import BaseLabel from '@/components/Label';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseSelect from '@/components/Select';
import BaseAdd from '@/components/Add';

export default {
  data() {
    return {
      dayNames: WorkingTime.getWeekDays(),
      horaries: [WorkingTime.getTemplatePeriodWeek(1)],
      originalData: [WorkingTime.getTemplatePeriodWeek(1)],
      showHoraries: {},
      tzDrawer: false,
      valueFirstPeriod: null,
      valueSecondPeriod: null,
      optionsFirstPeriod: [
        '00:00',
        '00:10',
        '00:20',
        '00:30',
        '00:40',
        '00:50',
        '01:00',
      ],
      optionsSecondPeriod: [
        '00:00',
        '00:10',
        '00:20',
        '00:30',
        '00:40',
        '00:50',
        '01:00',
      ],
      options: {
        pagination: false,
        padding: 20,
        updateOnMove: true,
        classes: {
          prev: 'splide__arrow--prev arrow-prev',
          next: 'splide__arrow--next arrow-next',
        },
      },
    };
  },

  created() {
    const self = this;
    StoreAPI.storeGetConfiguration('working_time').then((response) => {
      self.set(response);
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges()) {
      confirm(`${StringLanguage.confirmComplement}`, (res) => res && next());
      return;
    }

    next();
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      onBoardDone: (state) => state.store.onBoardDone,
    }),
  },
  methods: {
    cleanWorkingTime(time) {
      return String(time).replace(':', '');
    },
    correctPeriods(periods) {
      periods.forEach((period) => {
        period.days.forEach((day) => {
          day.active = !!day.active;
          day.open = day.open ? this.cleanWorkingTime(day.open) : null; // Remove os : do horario
          day.close = day.close ? this.cleanWorkingTime(day.close) : null; // Remove os : do horario
        });
      });

      return periods;
    },
    hasChanges() {
      // Corrigir os campos de horários em this.horaries e this.originalData
      const cleanedHoraries = this.correctPeriods(
        JSON.parse(JSON.stringify(this.horaries))
      );
      const cleanedOriginalHoraries = this.correctPeriods(
        JSON.parse(JSON.stringify(this.originalData))
      );

      // Faz a comparação por string dos dois objetos
      return (
        JSON.stringify(cleanedHoraries) !==
        JSON.stringify(cleanedOriginalHoraries)
      );
    },
    onSave() {
      if (this.hasChanges()) {
        if (this.$route.params.done) {
          let invalidDays = false;
          this.horaries.forEach((period) => {
            period.days.forEach((day) => {
              if (!day.open && day.close) {
                day.openTimeIsValid = false;
                invalidDays = true;
              }
              if (day.open && !day.close) {
                day.closeTimeIsValid = false;
                invalidDays = true;
              }
            });
          });

          if (invalidDays) {
            alert(StringLanguage.confirmInfoWithoutLeaveRoute);
            return false;
          }
        }

        if (this.validateDays()) this.save();
      } else {
        alert(StringLanguage.noChanges);
      }
    },
    set(response) {
      if (response.getErrors([]).length > 0) {
        console.log(response.getErrors([]));
        return;
      }

      let horaries = new WorkingTime([WorkingTime.getTemplatePeriodWeek(1)])
        .periods;
      let originalData = new WorkingTime([WorkingTime.getTemplatePeriodWeek(1)])
        .periods;

      if (response.getData({ working_time: [] }).working_time || false) {
        // Obtem os dados que vem da api ou então cria uma array default
        const periods =
          response.getData({ working_time: [] }).working_time || [];
        // Com base nos peridos retornados, recria o objeto WorkingTime
        const workingTime =
          periods.length > 0 ? periods : [WorkingTime.getTemplatePeriodWeek(1)];
        horaries = new WorkingTime(JSON.parse(JSON.stringify(workingTime)))
          .periods;
        originalData = new WorkingTime(JSON.parse(JSON.stringify(workingTime)))
          .periods;
      }

      Vue.set(this, 'horaries', horaries);
      Vue.set(this, 'originalData', originalData);
    },
    add() {
      this.horaries.push(WorkingTime.getTemplatePeriodWeek(2));
      this.$nextTick(() => {
        const elm = document.getElementById(
          `period-${this.horaries.length - 1}`
        );
        if (elm) {
          elm.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },
    remove(index) {
      this.horaries[index].remove = true;
      this.$forceUpdate();

      setTimeout(() => {
        this.horaries.splice(index, true);
      }, 200);
    },
    checkKey(e, currentValue) {
      let time = `${currentValue || ''}`.replace(':');

      if (e.target.selectionStart != e.target.selectionEnd) {
        time = time.substring(0, e.target.selectionStart + 1);
      }

      if ('0123456789'.indexOf(e.key) > -1) {
        if (time.length == 0 && '012'.indexOf(e.key) == -1) {
          e.preventDefault();
          return false;
        }
        if (time.length == 1 && time[0] == '2' && '0123'.indexOf(e.key) == -1) {
          e.preventDefault();
          return false;
        }
        if (time.length == 2 && '012345'.indexOf(e.key) == -1) {
          e.preventDefault();
          return false;
        }
      }
    },
    validateTime(e, vModel, key) {
      // Se o campo estiver ativo e o campo estiver vazio
      if (vModel.active && !vModel[key]) {
        vModel[`${key}TimeIsValid`] = false;
        return;
      }

      const [hours, minutes] = String(vModel[key])
        .replace(':', '')
        .padEnd(4, '0')
        .match(/.{1,2}/g);
      const date = new Date(0, 0, 0, hours, minutes);
      if (hours != date.getHours() || minutes != date.getMinutes()) {
        vModel[key] = '0000';
      } else {
        vModel[key] = vModel[key] ? `${hours}${minutes}` : '';
      }
    },
    validateDays() {
      let invalidDays = false;
      this.horaries.forEach((period) => {
        period.days.forEach((day) => {
          if (!day.open && day.close) {
            day.openTimeIsValid = false;
            invalidDays = true;
          }
          if (day.open && !day.close) {
            day.closeTimeIsValid = false;
            invalidDays = true;
          }

          if (day.active) {
            if (!day.open) {
              day.openTimeIsValid = false;
              invalidDays = true;
            }
            if (!day.close) {
              day.closeTimeIsValid = false;
              invalidDays = true;
            }
          }
        });
      });

      if (invalidDays) {
        alert('Preencha os horários dos dias selecionados.');
        return false;
      }

      return true;
    },
    save() {
      const self = this;

      const horaries = this.correctPeriods(
        JSON.parse(JSON.stringify(this.horaries))
      );

      return StoreAPI.storeConfiguration({
        working_time: horaries,
      }).then((response) => {
        self.set(response);
        this.$store.dispatch('store/getIsOpen');
        this.$store.dispatch('store/getConfigurations');

        if (!this.onBoardDone) {
          return this.$router.push({ name: 'onboard' });
        }

        alert(StringLanguage.saveSuccess);
      });
    },
    toggleHorary(period, day, value) {
      Vue.set(
        this.showHoraries,
        `${period}-${day}`,
        value || !this.showHoraries[`${period}-${day}`]
      );
    },
    activeDay(period, day) {
      if (!day.active) {
        this.toggleHorary(period, day.weeknum, true);
      }

      // desconsidera a validação quando um dia não está selecionado
      day.openTimeIsValid = true;
      day.closeTimeIsValid = true;
    },
    handleInput(_, event) {
      if (event.isTrusted) {
        // Obtem a posição do cursor no input
        let position = event.target.selectionStart;

        // Verifica se vai haver adição da máscara ao input
        if (StringLanguage.timeMask[position - 1] === ':' && event.data) {
          position++;
        }

        // Atualiza a posição do cursor no input
        this.$nextTick(() => {
          setTimeout(() => {
            event.target.setSelectionRange(position, position);
          }, 3);
        });
      }
    },
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseCheckbox,
    BaseLabel,
    BaseDrawer,
    BaseCard,
    BaseSelect,
    BaseAdd,
    SplideSlide,
    Splide,
    Multiselect,
  },
};
</script>
<style scoped>
.period-box {
  opacity: 1;
  transition: 0.2s linear;
}
.period-box.removing {
  opacity: 0;
}
.period-title {
  padding-bottom: 15px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  height: 50px;
  padding: 5px 0;
}
.period-week {
  display: flex;
}
.period-day {
  width: 100%;
}
.period-day.active {
  opacity: 1;
}
.period-day.inactive {
  opacity: 0.5;
}
.day-periods {
  padding: 20px 0 10px;
}
.day-periods > .horaries {
  background-color: var(--box);
  border-radius: 5px;
  padding: 0 15px 15px;
}
.period-day.inactive .day-periods {
  pointer-events: none;
}
.day-box {
  padding: 20px;
  background: var(--background);
}
.period-day .day-box {
  border-radius: 5px;
}
.period-day:not(.is-active) {
  opacity: 0.5;
}
.period-day.active {
  opacity: 1;
}
.start-end {
  color: #d9d9d9bf;
}
.start-end .next-day {
  color: #fc9;
  font-weight: 300;
}
.hairline {
  height: 20px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  margin: 5px 0 15px;
}
.tz-value {
  font-size: 1.4em;
  padding: 15px 20px;
  background: #f6f6f6;
  color: #999;
  margin-top: 20px;
}
.tz-value span {
  font-weight: 600;
}
.day {
  font-size: 12px;
}
@media screen and (min-width: 992px) {
  .period-week.desktop {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 20px;
  }
  .period-week.mobile {
    display: none;
  }
}
@media screen and (max-width: 991px) {
  .period-title {
    margin-bottom: 15px;
  }
  .period-week {
    flex-direction: column;
  }
  .period-week.desktop {
    display: none;
  }
  .period-day .day-horaries {
    flex-direction: column;
  }
  .period-day.opened .day-horaries {
    display: block;
    margin-bottom: 10px;
  }
  .period-day {
    margin-right: 0;
    border-right: none;
    margin-bottom: 10px;
    padding: 0 5px;
  }
  .period-day:first-child {
    padding-left: 0;
  }
  .day-horaries {
    display: flex;
  }
  .day-periods {
    padding: 0;
    margin-top: 10px;
  }
  .day-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    border-radius: 5px;
  }
  .arrow-next,
  .arrow-prev {
    top: 28px;
    padding: 0 10px;
    background: 0 0;
    color: #8c8c8c;
    height: 40px;
    width: 50px;
  }
  .arrow-next[disabled],
  .arrow-prev[disabled] {
    display: none;
  }
  .arrow-prev {
    left: 25px;
  }
  .arrow-next {
    right: 25px;
  }
}
</style>
